var liatan = {
  page_option: function(){
    
    AOS.init();
    
    $('.scroll_bottom').on('click', function(){
      $('html,body').animate({scrollTop: $(window).height()},300);
    });
    
 	 $('.insd_slider_1').bxSlider({
        auto: false,
        autoControls: false,
        speed: 500,         
        minSlides: 2,
        maxSlides: 2,
        moveSlides: 2 
      });
    
    $('.menu_hover_image').mouseenter(function(){
        var img = $(this).data('img');
      
        $('.menu_hover_image').addClass('active');
      
      
     setTimeout(function(){
        if(typeof img !=='undefined'){
           $('#menu-drawer').css('background-image', 'url('+img+')').addClass('active');
        }	
      },250);
       $(this).removeClass('active');
    }).mouseleave(function() {
      
      $('#menu-drawer').removeClass('active'); 
      $('.menu_hover_image').removeClass('active');
    });
    
    $('.header__icon--menu').on('click', function(){
      $('#menu-drawer').fadeToggle();
      
      setTimeout(function(){
      	$('.menu_list').toggleClass('in_active');
      },200);
    
    });
    
     
    $('.insd_link').on('click', function(){
      var url = $(this).attr('href');
      console.log(url);
      
    });
     
    
  },
  scroll_img: function(that, x){
    
       var transY = (x * 0.5), scale = 1 + (x * 0.0004), rotate =  (x * 0.006);
    	
      if($(window).width() < 768){
        transY = (x * 0.1);
      }
    
       var transform = 'translateY('+transY+'px)  translate3d(0,0,0) scale(1.17)'; // scale('+scale+') rotate('+rotate+'deg)';
       that.css({        
         WebkitTransform: transform,
         MozTransform: transform,
         msTransform: transform,
         transform: transform
       });
  },
  scroll_img_without_scale: function(that, x){
    
       var transY = (x * 0.2), scale = 1, rotate =  (x * 0.006);
    	
      if($(window).width() < 768){
        transY = (x * 0.02);
        scale =  1.1;
      }
    
       var transform = 'translateY('+transY+'px)  translate3d(0,0,0) scale('+scale+')'; // scale('+scale+') rotate('+rotate+'deg)';
       that.css({        
         WebkitTransform: transform,
         MozTransform: transform,
         msTransform: transform,
         transform: transform
       });
  },
  scroll_img_out: function(that, x){
    
       var transY = (x * 0.5) , scale = 1.2 - (x * 0.0004), rotate =  6 - (x * 0.006);
    
     if($(window).width() < 768){
        transY = (x * 0.1);
      }
         
    if(scale < 1){
      scale = 1;      
    }
    if(rotate < 0){
      rotate = 0;
    }
        var transform = 'translateY('+transY+'px)  translate3d(0,0,0) scale('+scale+')'; // rotate('+rotate+'deg)';
       that.css({        
         WebkitTransform: transform,
         MozTransform: transform,
         msTransform: transform,
         transform: transform
       });
  },
  scroll_img_with_zoom: function(that, x){    
       var transY = (x * 0.2), scale = 1.081 - (x * 0.0009), rotate =  (x * 0.006);
    	
      if($(window).width() < 768){
        transY = (x * 0.02);
        //scale =  1.1;
      } 
      if(scale < 1)
        scale = 1;
      if(scale > 1.07)
        scale = 1.07;
    
    if($(window).width() < 768){
        transY = (x * 0.02);
        if(scale > 1.03)
        scale = 1.03;
      } 
    
       var transform = 'translateY('+transY+'px)  translate3d(0,0,0) scale('+scale+')'; // scale('+scale+') rotate('+rotate+'deg)';
       that.css({        
         WebkitTransform: transform,
         MozTransform: transform,
         msTransform: transform,
         transform: transform
       });
  }
}

$(function(){
  liatan.page_option();
  
 
  
  
});

 

$.fn.isOnScreen = function(){
    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};